import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import Credibility from "@/components/home/Credibility";
import EditorialMarquee from "@/components/home/EditorialMarquee";
import AboutPreview from "@/components/home/AboutPreview";
import ServicesGrid from "@/components/home/ServicesGrid";
import ProcessTimeline from "@/components/home/ProcessTimeline";
import WhatToExpect from "@/components/home/WhatToExpect";
import CtaBand from "@/components/home/CtaBand";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo description="North Cadence helps professionals build their next career move with resume writing, LinkedIn optimisation, interview coaching, and a full career transition programme — plus recruitment and talent services for organisations." />
      <Hero />
      <Credibility />
      <AboutPreview />
      <ServicesGrid />
      <EditorialMarquee />
      <ProcessTimeline />
      <WhatToExpect />
      <CtaBand />
    </div>
  );
}
